import {t} from 'i18next';
import {Column, DataTable} from 'primereact';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../baseContainers/BaseDetailsContainer';
import ActionLink from '../components/ActionLink';
import ImageComponent from '../components/inputs/ImageComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import YesNoDialog from '../components/YesNoDialog';
import GroupModel from '../model/GroupModel';
import AccountService from '../services/AccountService';
import FileUploadService from '../services/FileUploadService';
import GroupService from '../services/GroupService';
import InternalUserService from '../services/MobileUserService';
import SettingService from '../services/SettingService';
import UserRoleService from '../services/UserRoleService';
import AppPrefixUtils from '../utils/AppPrefixUtils';
import constants from '../utils/constants';
import StringUtils from '../utils/StringUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class GroupDetailContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new GroupService());
        this.fileUploadService = new FileUploadService();
        this.groupService = new GroupService();
        this.state = {
            element: new GroupModel(),
            elementId: props.elementId,
            viewMode: this.props.viewMode,
            removeDialog: false,
            tableWithUsersVisible: false,
            showTableWithUsers: false,
            showConfirmRemoveDialog: false,
            activeIndex: 0,
            name: undefined,
            users: [],
            user: undefined,
            selectedUsers: [],
            globalFilterValue: '',
            loading: true,
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.userRoleService = new UserRoleService();
        this.userService = new AccountService();
        this.mobileUserService = new InternalUserService();
        this.initBeforeSetElement = this.initBeforeSetElement.bind(this);
        this.handleValidForm = this.handleValidForm.bind(this);
        this.handleDeleteRow = this.handleDeleteRow.bind(this);
        this.handleUserSelectionChange = this.handleUserSelectionChange.bind(this);
        this.handleUserSelectionChangeFromDropdown = this.handleUserSelectionChangeFromDropdown.bind(this);
        this.uploadIconHandler = this.uploadIconHandler.bind(this);
        this.handleRemoveAssignedUser = this.handleRemoveAssignedUser.bind(this);
        this.actionTemplate = this.actionTemplate.bind(this);
        this.actionTemplateToJoinGroupName = this.actionTemplateToJoinGroupName.bind(this);
        this.prepareValidOptionsList = this.prepareValidOptionsList.bind(this);
    }

    onSelect = (e) => {
        this.setState(
            {
                selectedFile: e.files[0],
            },
            () => {
                this.uploadHandler();
            }
        );
    };

    onClear = () => {
        this.setState({
            selectedFile: undefined,
        });
    };

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    initBeforeSetElement() {
        const criteria = {
            groupIdExcluded: this.props.elementId,
            firstResult: 0,
            maxResults: constants.SC_MAX_RESULT,
            sortField: 'name',
            sortAsc: true,
        };

        this.mobileUserService
            .getList(criteria)
            .then((users) => {
                this.setState({users: users.content});
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId} = this.state;
        this.beforeUpdateElement(viewMode, elementId);
    }

    beforeUpdateElement(viewMode, elementId) {
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId)
                .then((data) => {
                    this.setState({loading: false}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    prepareFooterItems() {
        const {viewMode, detailUrl, editUrl} = this.props;
        const editHref = `${editUrl}/${this.state.element?.id}`;
        const detailHref = `${detailUrl}/${this.state.element?.id}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW',
            },
            {
                label: t('global.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: this.props.viewMode === 'VIEW' || this.props.viewMode === 'EDIT',
            },
        ];
    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-left',
                rendered: true,
            },
        ];
    }

    handleDeleteRow(rowData) {
        return (
            <ActionLink
                className='p-link float-right'
                handleClick={(e) => this.handleOpenRemoveDialog(e, rowData.id)}
                variant='red'
                iconName='mdi-trash-can'
                iconSide='left'
                iconSize='xs'
                iconColor='red'
            />
        );
    }
    handleOpenRemoveDialog(e, idToRemove) {
        if (e) {
            e.preventDefault();
        }
        this.setState({removeDialog: true, idToRemove});
    }

    goBackUrl() {
        const {backUrl} = this.props;
        return backUrl;
    }

    handleEditMode() {
        this.setState({
            viewMode: 'EDIT',
        });
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }

    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .remove(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('groups.successRemove'));
                    // window.location.href = backUrl;
                    this.props.history.push(backUrl);
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(t('groups.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    handlePublish() {
        this.setState({
            showPublishDialog: true,
        });
    }

    getAddSucces() {
        return t('groups.createSuccess');
    }

    getUpdateSucces() {
        return t('groups.updateSuccess');
    }

    prepareElementBeforeRequest(element) {
        return element;
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid'>
                <YesNoDialog
                    onChange={this.publish}
                    visible={this.state.showPublishDialog}
                    header={t('groups.publishHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showPublishDialog: false});
                    }}
                >
                    <span>{t('groups.publishBody')}</span>
                </YesNoDialog>
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('groups.removeGroupHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    <span>{t('groups.deleteGroupConfirmation')}</span>
                </YesNoDialog>

                {this.renderView()}
            </div>
        );
    }

    onRemoveAction(callback) {
        this.blockUi();
        this.service
            .remove(this.state.idToRemove)
            .then(() => {
                this.unblockUi();
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.hideRemoveConfirmation();
            });
    }

    getContainerListName() {
        return 'groups-list-container';
    }

    breadCrumbItems() {
        return [
            {name: t('groups.name'), url: '/groups-list'},
            this.props.viewMode === 'NEW' ? {name: t('groups.creating'), url: ``} : {name: t('groups.details'), url: ``},
        ];
    }

    handleValidForm() {
        const request = {
            selectedUsers: this.state.element.users.map((i) => i.id),
            iconTemporaryFileUrl: this.state.element.iconTemporaryFileUrl,
            name: this.state.element.name,
        };
        const requestAdd = {
            selectedUsers: this.state.element.users.map((i) => i.id),
            iconTemporaryFileUrl: this.state.element.iconTemporaryFileUrl,
            name: this.state.element.name,
        };
        if (this.props.viewMode !== 'NEW') {
            if (this.state.element.iconTemporaryFileUrl !== null) {
                this.groupService
                    .updateGroupAndAssignUsers(this.state.elementId, request)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                        this.unblockUi();
                    });
            } else {
                this.showErrorMessage(t('groups.avatarRequired'), 10000);
                this.unblockUi();
            }
        } else {
            this.groupService
                .add(requestAdd)
                .then((response) => {
                    this.afterAddSuccess(response);
                })
                .catch((err) => {
                    this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    this.unblockUi();
                });
        }
    }
    handleUserSelectionChange(list) {
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                users: list,
            },
        }));
    }

    handleUserSelectionChangeFromDropdown(a, b, c, list) {
        const selectedUsers = this.state.element.users.filter((u) => u.email !== c.value.email);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                users: selectedUsers.concat(c.value),
            },
        }));
    }

    handleRemoveAssignedUser(element, e) {
        if (e) {
            e.preventDefault();
        }
        const modifiedList = this.state.element.users;
        const optionsList = this.state.users;
        let found = false;
        let indexOfRemoved = -1;
        if (modifiedList !== undefined && modifiedList.length > 0) {
            modifiedList.forEach((el, i) => {
                if (el['id'] === element['id']) {
                    found = true;
                    indexOfRemoved = i;
                    return;
                }
            });
        }
        modifiedList.splice(indexOfRemoved, 1);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                users: modifiedList,
            },
            users: optionsList,
        }));
    }

    uploadIconHandler(uploadedFile) {
        this.setState((prevState) => ({
            uploadedFile,
            element: {
                ...prevState.element,
                iconTemporaryFileUrl: uploadedFile.uuid,
            },
        }));
    }

    actionTemplate(element) {
        return (
            <div>
                <ActionLink
                    className='p-link float-right'
                    handleClick={(e) => {
                        this.handleRemoveAssignedUser(element, e);
                    }}
                    variant='blue'
                    iconName='mdi-trash-can'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'
                />
            </div>
        );
    }
    actionTemplateToJoinGroupName(item) {
        return (
            <div>
                <div>
                    {item.name}
                    {!StringUtils.isBlank(item.groupNames) ? ` ( ${t('groups.assignedTo')}  ${item.groupNames})` : ''}
                </div>
            </div>
        );
    }

    prepareValidOptionsList() {
        let selectedUsersId = this.state.element?.users.map((cu) => cu.id);
        return this.state?.users.filter((u) => !selectedUsersId?.includes(u.id));
    }

    renderDetails() {
        return (
            <div>
                {this.props.viewMode === 'VIEW' ? (
                    <div className='title-section-container'>
                        <span className='p-label quiz-section-label'>{t('groups.infoHeader')}</span>
                    </div>
                ) : null}
                <div className='column'>
                    <InputTextComponent
                        id='name'
                        name='name'
                        label={t('groups.groupName')}
                        colClass='col-md-6'
                        value={this.state.element.name}
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />
                    <div className=' row p-label'>
                        <label>{this.props.viewMode === 'VIEW' ? t('groups.avatar') : t('groups.avatar') + t('global.requiredSign')}</label>
                    </div>
                    <ImageComponent
                        key='action-icon'
                        srcUrl={`${this.service.getPath()}/avatar/${this.state.element?.icon?.uuid}?token=${this.authService?.getToken()}`}
                        alt={t('groups.avatar')}
                        notValidImageTypeErrorMessage={() => {
                            this.showErrorMessage(t('image.notValidImageType'));
                        }}
                        handleRemove={(e) => {
                            this.setState((prevState) => ({
                                element: {
                                    ...prevState.element,
                                    icon: null,
                                    removeIcon: true,
                                    iconTemporaryFileUrl: null,
                                },
                            }));
                        }}
                        errorMessage={this.showErrorMessage}
                        imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                        fileSizeToTranslation={this.state.fileSizeToTranslation}
                        attachment={this.state.element.icon}
                        setFile={this.uploadIconHandler}
                        t={t}
                        viewMode={this.props.viewMode}
                        fileUploadService={this.fileUploadService}
                        validator={this.validator}
                        validators={'required'}
                    />
                    <div className='column'>
                        {this.props.viewMode === 'EDIT' || this.props.viewMode === 'NEW' ? (
                            <div>
                                <InputDropdownComponent
                                    id='users'
                                    name='users'
                                    colClass='col-md-12'
                                    label={t('groups.checkUsers')}
                                    value={this.state.element.user}
                                    onChange={this.handleUserSelectionChangeFromDropdown}
                                    viewMode={this.props.viewMode}
                                    options={this.prepareValidOptionsList()}
                                    dataKey='name'
                                    optionLabel='name'
                                    filter
                                    filterBy='name'
                                    stateField={``}
                                    itemTemplate={this.actionTemplateToJoinGroupName}
                                />
                            </div>
                        ) : null}
                    </div>
                    {this.props.viewMode === 'VIEW' ? (
                        <div className='title-section-container'>
                            <span className='p-label quiz-section-label'>{t('groups.assignedUsers')}</span>
                        </div>
                    ) : (
                        <div className='title-section-container'>
                            <span className='p-label quiz-section-label'>{t('groups.toAssignedUsers')}</span>
                        </div>
                    )}

                    {this.props.viewMode === 'VIEW' ? (
                        <div>
                            <DataTable
                                value={this.state.element.users}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[10, 25, 50]}
                                dataKey='id'
                                loading={this.state.loading}
                                responsiveLayout='scroll'
                                emptyMessage={t('list.empty')}
                                viewMode='VIEW'
                                onChange={this.handleChange}
                            >
                                <Column field='name' header={t('mobileUser.name')} />
                                <Column field='email' header={t('mobileUser.email')} />
                            </DataTable>
                        </div>
                    ) : (
                        <DataTable
                            value={this.state.element.users}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 25, 50]}
                            dataKey='id'
                            loading={this.state.loading}
                            responsiveLayout='scroll'
                            emptyMessage={t('list.empty')}
                            viewMode='VIEW'
                            onChange={this.handleChange}
                            sortField='name'
                            sortOrder
                        >
                            <Column field='name' header={t('mobileUser.name')} />
                            <Column field='email' header={t('mobileUser.email')} />
                            <Column
                                key='actions'
                                header={t('global.action')}
                                body={this.actionTemplate}
                                className='table-column-action'
                                //handleRemove
                            />
                        </DataTable>
                    )}
                </div>
            </div>
        );
    }
}

GroupDetailContainer.defaultProps = {
    backUrl: '/groups-list',
    editUrl: '/groups/edit',
    detailUrl: '/groups/details',
    lazy: true,
};

GroupDetailContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
    afterSave: PropTypes.func,
};

export default withRouter(withTranslation()(GroupDetailContainer));
